/**
 * 专利镖局 专利缴费
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>官费发票管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.zlmc" style="width:120px" placeholder="输入专利名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" style="width:120px" placeholder="输入联系方式"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.zlbh" style="width:120px" placeholder="输入专利号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.company" style="width:120px" placeholder="输入公司名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.serviceFee" style="width:100px" placeholder="请选择">
          <el-option v-for="type in status" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择开始时间" style="width:165px"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择结束时间" style="width:165px"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="handleCheckFee" title="批量处理">处理</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column align="center" prop="zlmc" label="专利名称" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zlbh" label="专利号" width="130" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="wx_name" label="微信昵称" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="mobile" label="联系方式" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="attribution" label="归属地" width="60" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="fee_string" label="缴费明细" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="total_fee" label="缴费总额" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="order_fwf" label="服务费" width="60"  show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column align="center" prop="order_fwf" label="服务费发票" width="120"  show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column align="center" prop="service_bill" label="服务费发票" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper" style="text-align: center">
              <el-tag :type="ORDER_FWF[scope.row.service_bill].type">
                {{ORDER_FWF[scope.row.service_bill].order_fwf}}
              </el-tag>
            </div>
          </template> 
      </el-table-column>
      <el-table-column align="center" prop="pay_time" label="支付时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="invoice_info" label="票据信息" width="140" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column align="center" prop="address_info" label="邮寄信息" width="90" show-overflow-tooltip>
      </el-table-column> -->
      <!-- <el-table-column align="center" prop="email" label="邮箱" width="140" show-overflow-tooltip>
      </el-table-column> -->
       <!-- <el-table-column align="center" prop="status" label="支付状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper" style="text-align: center">
              <el-tag :type="ASSET_STATUS[scope.row.status].type">
                {{ASSET_STATUS[scope.row.status].status}}
              </el-tag>
            </div>
          </template> 
      </el-table-column> -->
      <el-table-column align="center" prop="sfqy" label="是否处理" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper" style="text-align: center">
              <el-tag :type="ASSET_SFQY[scope.row.sfqy].type">
                {{ASSET_SFQY[scope.row.sfqy].sfqy}}
              </el-tag>
            </div>
          </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          <!-- <el-button size="mini" type="warning" title="针对错误滞纳金或年费,谨慎操作!" @click="handleRefund(scope.$index, scope.row)">退款</el-button> -->
          <el-button size="mini" type="danger" @click="handleFee(scope.$index, scope.row)" title="已开发票修改状态">处理</el-button>
          <el-button size="mini" type="primary" @click="handleTicket(scope.$index, scope.row)" title="上传发票">上传</el-button>
          <el-button size="mini" type="primary" @click="handleBill(scope.$index, scope.row)" title="查看发票">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利名称">
              <el-input size="small" v-model="infoForm.zlmc" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利号">
              <el-input size="small" v-model="infoForm.zlbh" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请人">
              <el-input size="small" v-model="infoForm.sqr" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="发明人">
              <el-input size="small" v-model="infoForm.fmr" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利类型">
              <el-input size="small" v-model="infoForm.zllx" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="缴费明细">
              <el-input size="small" v-model="infoForm.fee_string" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="缴费总额">
              <el-input size="small" v-model="infoForm.total_fee" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="支付时间">
              <el-input size="small" v-model="infoForm.pay_time" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址">
              <el-input size="small" v-model="infoForm.email" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微信昵称">
              <el-input size="small" v-model="infoForm.wx_name" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input size="small" v-model="infoForm.mobile" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="票据信息">
              <el-input size="small" v-model="infoForm.invoice_info" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="邮寄信息">
              <el-input size="small" v-model="infoForm.address_info" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="发票类型">
              <el-input size="small" v-model="infoForm.invoice_get_name" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="支付状态">
              <el-input size="small" v-model="infoForm.status" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="是否处理">
              <el-input size="small" v-model="infoForm.sfqy" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="下单时间">
              <el-input size="small" v-model="infoForm.add_time" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="是否开票">
              <el-input size="small" v-model="infoForm.service_bill" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="备注">
          <el-input size="small" v-model="infoForm.remark" auto-complete="off" placeholder="请输入微信证书路径" disabled></el-input>
        </el-form-item> -->
      </el-form>
    </el-dialog>
    <!-- 退款申请界面 -->
    <el-dialog :title="title" :visible.sync="refundFormVisible" width="50%" @click="closeDialog('refundForm')">
      <el-form label-width="120px" :model="refundForm" ref="refundForm">
         <el-form-item label="专利名称">
              <el-input size="small" v-model="refundForm.zlmc" auto-complete="off" disabled></el-input>
         </el-form-item>
        <el-form-item label="订单号">
              <el-input size="small" v-model="refundForm.order_sn" auto-complete="off" disabled></el-input>
         </el-form-item>
         <el-form-item label="订单总金额">
              <el-input size="small" v-model="refundForm.total_fee" auto-complete="off" disabled></el-input>
         </el-form-item>
         <!-- <el-form-item label="退款类型">
              <el-input size="small" v-model="refundForm.order_sn" auto-complete="off" disabled></el-input>
         </el-form-item> -->
         <el-form-item label="退款类型" prop="refund_type">
                <el-radio-group type="kind" v-model="refundForm.refund_type"> 
                    <el-radio v-model="refundForm.refund_type" :label="1" style="font-size: 25px">部分退款</el-radio>
                    <el-radio v-model="refundForm.refund_type" :label="2">全额退款</el-radio>
                </el-radio-group>
            </el-form-item>
         <el-form-item label="退款金额">
              <el-input size="small" v-model="refundForm.refund_fee" auto-complete="off"></el-input>
         </el-form-item>
         <el-form-item label="退款理由">
              <el-input size="small" v-model="refundForm.refund_reason" auto-complete="off"></el-input>
         </el-form-item>
         <el-form-item>
              <el-button size="mini" type="primary" @click="commitRefund">提交</el-button>
              <el-button size="mini" @click='closeDialog("refundForm")'>取消</el-button>
            </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 上传发票界面 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="billFormVisible" width="50%" @click="closeDialog('billForm')">
      <el-form label-width="120px" :model="billForm" ref="billForm">
        <el-form-item label="上传发票">
            <el-upload
              class="upload-demo"
              drag
              :action=uploadExcel
              :headers=setHeader
              :before-upload="beforeAvatarVideoUpload"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :show-file-list="false"
              multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <!-- <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M
                <span style="margin-left: 15px;color: #551A8B;cursor: pointer;" title="下载批量导入excel模板" @click="downloadImportExcel()">下载模板</span>
              </div> -->
            </el-upload>
        </el-form-item>
        <el-form-item label="专利名称">
            <el-input size="small" v-model="billForm.zlmc" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="专利号">
            <el-input size="small" v-model="billForm.zlbh" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="发票地址">
            <el-input size="small" v-model="billForm.bill_url" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="开票日期">
            <el-input size="small" v-model="billForm.open_time" auto-complete="off" placeholder="日期格式：2023-03-15"></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否发送">
            <el-input size="small" v-model="billForm.open_time" auto-complete="off" placeholder="日期格式：2023-03-15"></el-input>
        </el-form-item> -->
        <el-form-item>
        <el-row class="demo-autocomplete">
              <el-col :span="9">
                <div class="sub-title" style="color: #909399">缴费项目</div>
              </el-col>
              <el-col :span="9">
                <div class="sub-title" style="color: #909399">缴费金额</div>
              </el-col>
        </el-row>
      </el-form-item>

       <el-form-item
        v-for="(domain, index) in billForm.pay_able"
        :label="'费用' + index"
        :key="domain.key"
      >
      <el-row class="demo-autocomplete">
            <el-col :span="6">
              <el-input :prop="domain.category" v-model="domain.category" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:第6年年费"></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 15px">
            <el-input :prop="domain.money" v-model="domain.money" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:1200"></el-input>
            </el-col>
            <el-button @click.prevent="removeDomain(domain)" style="margin-left: 15px">删除</el-button>
            <el-button @click.prevent="addOnNodeDomain(domain)" title="当前节点上方添加录入框">添加(上)</el-button>
            <el-button @click.prevent="addNextNodeDomain(domain)" title="当前节点下方添加录入框">添加(下)</el-button>
      </el-row>
        <!-- <el-input v-model="domain.value"></el-input> -->
        
      </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="commitTicket">提交</el-button>
            <el-button size="mini" @click='closeDialog("billForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 查看发票页面 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="billSeeFormVisible" height="60vh" width="50%" @click="closeDialog('billSeeForm')">
      <el-form label-width="120px" ref="billSeeForm">
        <el-table size="small" ref="multipleTable" :data="billData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
          <el-table-column align="center" prop="bill_name" label="发票名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" prop="add_time" label="上传时间" show-overflow-tooltip>
          </el-table-column>
            <el-table-column align="center" label="操作" min-width="120">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="showBill(scope.$index, scope.row)" title="查看发票">查看</el-button>
                <el-button size="mini" type="error" @click="deleteBill(scope.$index, scope.row)" title="删除发票">删除</el-button>
              </template>
            </el-table-column>
        </el-table>
      </el-form>
    </el-dialog>
    
    <!-- 发票预览 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="billPreviewVisible" width="50%">
      <div>
        <iframe :src="bill_url" style="height: 60vh;width: 100%;"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { wechatFeePayList, wechatServiceBill, wechatUrl, 
wechatCheckServiceBill, patentPayInfo, patentRefundFee,
wechatUploadBill, wechatBillList, wechatDelBill } from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      refundFormVisible: false, //控制退款申请页面显示与隐藏
      billFormVisible: false, //控制发票上传页面显示与隐藏
      billSeeFormVisible: false, //控制查看发票页面显示与隐藏
      billPreviewVisible: false, //控制发票预览页面显示与隐藏
      title: '缴费详情',
      multipleSelection: [],
      ASSET_STATUS: {
      '1': { 'status': '未支付', 'type': 'info' },
      '2': { 'status': '已支付', 'type': 'primary' },
      '3': { 'status': '退款中', 'type': 'warning' },
      '4': { 'status': '已退款', 'type': 'danger' }
      },
      ORDER_FWF: {
      '1': { 'order_fwf': '未开发票', 'type': 'primary' },
      '2': { 'order_fwf': '已开发票', 'type': 'warning' }
      },
      ASSET_SFQY: {
      '1': { 'sfqy': '未处理', 'type': 'primary' },
      '2': { 'sfqy': '已处理', 'type': 'info' }
      },
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      status: [
        { key: '全部', value: 0 },
        { key: '未开发票', value: 1 },
        { key: '已开发票', value: 2 }
      ],
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel: wechatUrl + '/index/base/uploadLocalFile',
      infoForm: {
        add_time: '',
        address: '',
        address_mobile: '',
        address_name: '',
        invoice_get_name: '',
        invoice_name: '',
        mobile: '',
        pay_time: '',
        sqr: '',
        sqrq: '',
        status: '',
        total_fee: '',
        wx_name: '',
        zlbh: '',
        zllx: '',
        zlmc: '',
        invoice_info: '',
        fee_string: '',
        token: localStorage.getItem('logintoken')
      },
      billForm: {
        bill_url: '',
        order_sn: '',
        uid: '',
        zlmc: '',
        zlbh: '',
        pay_able: [],
        open_time: '',
        pay_able: [{
          category: '',
          money: ''
        }]
      },
      // refund_type退款类型 1 部分退款 2 全额退款
      refundForm: {
        zlmc: '',
        order_sn: '',
        total_fee: '',
        refund_fee: '',
        refund_reason: '',
        refund_type: ''
      },
      formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        zlmc: '',
        mobile: '',
        zlbh: '',
        status: 2,
        serviceFee: 0,
        company: ''

        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      billData: [], //发票数据
      // 文件上传列表
      fileList: [],
      // 发票地址
      bill_url: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.billForm.bill_url = response.data.url
          console.log(response)
          // this.excelFormVisible = false
          // this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
      //  if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
      //     that.$message({
      //         type: 'error',
      //         message: '上传文件只能为excel文件，且为xlsx,xls格式!'
      //     })
      //     return false
      //   }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
       this.loading = true
    //   this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */

      wechatFeePayList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 导出excel
    exportCheck() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
      }
       this.$confirm('确定导出勾选的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(() => {
          const idStr = JSON.stringify(idsArr)
          console.log(idStr)
          // console.log(data)
          window.location.href = wechatUrl + "/admin/patent/exportPayExcel?ids=" + idStr
       })
       .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    exportAll() {
       this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
          window.location.href = wechatUrl + "/admin/patent/exportPayAllExcel?zlmc="+this.formInline.zlmc+"&mobile="+this.formInline.mobile+"&zlbh="+this.formInline.zlbh+"&status="
          +this.formInline.status+"&sfqy="+this.formInline.sfqy+"&zfsj="+this.formInline.zfsj+"&start_time="+this.formInline.start_time+"&end_time="+this.formInline.end_time;
          })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    // 批量处理
    handleCheckFee() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
        if(item.service_bill != 1){
          return false;
        }
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录或勾选中存在已开票的订单'
          })
          return false;
      }
       this.$confirm('确定批量处理缴费订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(() => {
          const idStr = JSON.stringify(idsArr)
          const handleParam = {ids:idStr}
          wechatCheckServiceBill(handleParam)
            .then(res => {
              console.log(res)
              res = checkLogin(res)
              if (res.code == 200) {
                this.loading = false
                this.$message({
                  type: 'success',
                  message: '处理成功'
                })
                this.getdata(this.formInline)
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
          // console.log(data)
          // 请求接口
       })
       .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      // 查询订单详情
      patentPayInfo({order_sn:row.order_sn})
      .then(res => {
        if(res.code == 200){
            console.log(res)
            this.infoForm = res.data
            this.editFormVisible = true
        }else{
          this.$message({
            type: 'error',
            message: res.msg
        })
        }
      })
      .catch(res => {
        this.$message({
          type: 'error',
          message: '系统错误!'
        })
      })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 处理专利年费缴纳
    handleFee(index, row) {
      if(row.service_bill == 2){
        this.$message({
          type: 'info',
          message: '该专利缴费订单服务费发票已开'
        })
        return false;
      }
      this.$confirm('确定已经处理了吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const handleParam = {'id':row.id}
          console.log(handleParam)
          this.loading = true
          wechatServiceBill(handleParam)
            .then(res => {
              console.log(res)
              res = checkLogin(res)
              if (res.code == 200) {
                this.loading = false
                this.$message({
                  type: 'success',
                  message: '处理成功'
                })
                this.getdata(this.formInline)
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消处理'
          })
        })
    },
    // 显示上传发票界面
    handleTicket(index, row) {
      this.title = '发票上传'
      this.billForm.bill_url = ''
      this.billForm.order_sn = row.order_sn
      this.billForm.uid = row.uid
      this.billForm.zlmc = row.zlmc
      this.billForm.zlbh = row.zlbh
      this.billForm.open_time = ''
      this.billForm.pay_able = [{category: '',money: ''}]
      this.billFormVisible = true
    },
    handleBill(index, row){
      // 查询发票列表
      let order_sn = row.order_sn
      wechatBillList({order_sn: order_sn})
      .then(res=>{
        if(res.code != 200){
          this.$message({
            type: 'info',
            message: res.msg
          })
            return false
        }
        this.title = '查看发票'
        this.billSeeFormVisible = true
        this.billData = res.data
      })
     
    },
    // 查看发票
    showBill(index,row) {
      this.title = '发票预览'
      this.bill_url = row.bill_url
      this.billPreviewVisible = true
      // console.log(row)
    },
    // 删除发票
    deleteBill(idnex,row) {
      console.log(row)
      let id = row.id
      let order_sn = row.order_sn
      let that = this
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        wechatDelBill({id: id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            wechatBillList({order_sn: order_sn})
            .then(resA=>{
              if(resA.code == 200){
                that.billData = resA.data
              }
            })
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
    },
    // 提交发票
    commitTicket(){
      // let param = this.billForm
      let pay_able = this.billForm.pay_able
      let bill_url = this.billForm.bill_url
      let order_sn = this.billForm.order_sn
      let uid = this.billForm.uid
      let zlbh = this.billForm.zlbh
      let zlmc = this.billForm.zlmc
      let open_time = this.billForm.open_time
      if(bill_url.length <= 0){
        this.$message({
          type: 'error',
          message: '发票必须上传'
        })
        return false
      }
      if(open_time.length <= 0){
        this.$message({
          type: 'error',
          message: '开票日期必须填写'
        })
        return false
      }
      let param = {
        uid: uid,
        bill_url: bill_url,
        order_sn: order_sn,
        zlbh: zlbh,
        zlmc: zlmc,
        open_time: open_time,
        pay_able: JSON.stringify(pay_able)
      }
      wechatUploadBill(param)
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.billFormVisible = false
          this.getdata(this.formInline)
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'editForm'){
        this.editFormVisible = false
      }else if(formName == 'refundForm'){
        this.refundFormVisible = false
      }else if(formName == 'billForm'){
        this.billFormVisible = false
      }else if(formName == 'billSeeForm'){
        this.billSeeFormVisible = false
      }
      this.$refs[formName].resetFields()
    },
    //根据不同值显示不同文本内容
    statusFormat(row,column){
      if(row.status == 1){
          return '未支付'
      }else if(row.status == 2){
          return '已支付'
      }else if(row.status == 3){
          return '退款中'
      }else if(row.status == 4){
          return '已退款'
      }else{
          return '未知'
      }
    },
    invoiceTypeFormat(row,column){
        if(row.invoice_type == 1){
          return '纸质发票'
        }
        else if(row.invoice_type == 2){
          return '电子发票'
        }else{
          return '无'
        }
    },
    sfqyFormat(row,column){
        if(row.sfqy == 1){
          return '未处理'
        }else{
          return '已处理'
        }
    },
    // 显示退款申请窗口
    handleRefund(index,row){
      if(row.sfqy == 2){
        this.$message({
            type: 'warning',
            message: '已处理的订单不能退款!'
        })
        return false
      }
      this.refundForm.zlmc = row.zlmc
      this.refundForm.order_sn = row.order_sn
      this.refundForm.total_fee = row.total_fee
      this.refundForm.refund_type = ''
      this.refundForm.refund_fee = ''
      this.refundForm.refund_reason = ''
      this.refundFormVisible = true
    },
    // 提交退款申请
    commitRefund(){
      let order_sn = this.refundForm.order_sn
      let refund_type = this.refundForm.refund_type
      let refund_fee = this.refundForm.refund_fee
      let refund_reason = this.refundForm.refund_reason
      if(refund_type.length <= 0 || refund_fee.refund_fee <= 0 || refund_reason.length <= 0 ){
          this.$message({
              type: 'warning',
              message: '请填写完申请单!'
          })
          return false
      }
      let param = {
        order_sn: order_sn,
        refund_type: refund_type,
        refund_fee: refund_fee,
        refund_reason: refund_reason
      }
      // 提交退款
       patentRefundFee(param)
        .then(res => {
          if(res.code == 200){
             this.$message({
                type: 'success',
                message: res.msg
            })
            this.refundFormVisible = false
           this.getdata(this.formInline)
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
        .catch(res => {
          this.$message({
            type: 'error',
            message: '系统错误!'
          })
        })
      
      console.log(this.refundForm)
    },
    removeDomain(item) {
      var index = this.billForm.pay_able.indexOf(item)
      if (index !== -1) {
        this.billForm.pay_able.splice(index, 1)
      }
    },
    // 当前节点添加输入行
    addOnNodeDomain(item) {
      var index = this.billForm.pay_able.indexOf(item)
      this.billForm.pay_able.splice(index, 0,{key: Date.now()})
    },
    addNextNodeDomain(item) {
      var index = this.billForm.pay_able.indexOf(item)
      this.billForm.pay_able.splice(index+1, 0,{key: Date.now()})
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/wechat/serviceFee.vue